<template>
  <div>
    <div class="background-image-login" 
    :style="[settings.loginBackgroundImage && settings.loginBackgroundImage.absoluteUri ? {'backgroundImage': 'url(' + settings.loginBackgroundImage.absoluteUri + ')'} : {'backgroundImage': 'url(img/temp/cook.jpg)'}]"
    ></div>
    <!-- /.background-image-dashboard -->
    <base-header class="pt-4 pb-6" type="none">
      <b-row align-h="center">
        <b-col cols="10" lg="4" class="text-center">
          <h1 class="page-title">DID YOU KNOW?</h1>

          <p class="text-lead text-white mb-2" v-if="randomEntry">{{ randomEntry }}</p>
        </b-col>
      </b-row>
    </base-header>

    <!--Charts-->
    <b-container fluid class="mt--5">
      <b-row class="js-sticky-container" data-sticky-container>
        <b-col xl="8">
          <my-recipes-table></my-recipes-table>

          <featured-masonry v-if="this.$store.state.collections.featured"></featured-masonry>
        </b-col>

        <b-col xl="4">
          <to-do-list class="js-sticky"></to-do-list>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>

import swal from 'sweetalert2';
import Sticky from 'sticky-js';

// Components
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';

// Lists
import ToDoList from './Lists/ToDoList';

// Articles
import FeaturedMasonry from './Collections/Featured';

// Tables
import MyRecipesTable from './Tables/MyRecipesTable';
import Settings from "@/whipstir";

export default {
  components: {
    RouteBreadCrumb,
    ToDoList,
    FeaturedMasonry,
    MyRecipesTable,
  },
  data() {
    return {
      randomEntry: Settings.foodFacts[Math.floor(Math.random() * Settings.foodFacts.length)],
      company: this.$store.state.company
    };
  },
  computed: {
    settings() {
      return this.$store.state.settings.current;
    }
  },
  methods: {
    initSticky() {
      let sticky = new Sticky('.js-sticky', {
        marginTop: 100
      });
      let button = document.querySelector('.sidenav-toggler');

      button.addEventListener('click', function(){
        setTimeout(function(){
          sticky.update();
        }, 150)
      });
    }
  },
  created() {
    //if(this.$store.state.recipes.myRecipes && Object.keys(this.$store.state.recipes.myRecipes).length === 0){
      const { dispatch } = this.$store;
      dispatch("recipes/getMyRecipes", {'userId':this.$store.state.authentication.user.user.id});
    //}
  },
  updated() {
    this.initSticky();
  }
};
</script>
<style></style>
